var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"conversations"},_vm._l((_vm.conversations),function(conversation){return _c('div',{key:conversation.id},[_c('a',{attrs:{"href":'/' + conversation.id}},[_vm._v(_vm._s(conversation.id))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }